import React from 'react';
import { Link } from 'react-router-dom';

const CTA = () => {
  return (
    <div className="bg-hero-gradient">
      <div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
          <span className="block">Ready to boost your career?</span>
          <span className="block">Become a VIP member today.</span>
        </h2>
        <p className="mt-4 text-lg leading-6 text-white/90">
          Join thousands of students who are already building their future with CampusQube.
        </p>
        <Link
          to="/signup"
          className="mt-8 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-vibrant-red bg-white hover:bg-gray-100 sm:w-auto transition-colors shadow-lg"
        >
          Become a VIP Member
        </Link>
      </div>
    </div>
  );
};

export default CTA;
